// extracted by mini-css-extract-plugin
export default {"container":"H2-z","heading":"I2-z","links":"J2-z","copy":"K2-z","subCopy":"L2-z","linksLeft":"M2-z","linksCenter":"N2-z","linksRight":"O2-z","link":"P2-z","onlyLink":"Q2-z"};